<div class="right-panel" [class.visible]="isVisible" [class.expanded]="isExpanded" [class.collapsed]="isCollapsed">
    <!-- Main Content Area - Left Side -->
    <div class="main-area" [class.hidden]="isCollapsed">
        <!-- Top Panel with Title and Controls -->
        <div class="top-panel">
            <div class="panel-title" *ngIf="!isCollapsed">
                <span class="material-symbols-rounded" aria-hidden="true">{{ content?.icon || 'schedule' }}</span>
                <h5>{{ content?.title || '-' }}</h5>
            </div>

            <div class="panel-controls">
                <button
                    type="button"
                    class="btn-control expand"
                    (click)="toggleExpanded()"
                    [title]="isExpanded ? 'Collapse' : 'Expand'"
                    *ngIf="!isCollapsed && showExpandableButton"
                >
                    <span class="material-symbols-rounded" aria-hidden="true">
                        {{ isExpanded ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}
                    </span>
                </button>
                <button
                    type="button"
                    class="btn-control hide-btn"
                    (click)="toggleCollapsed()"
                    title="Hide content"
                    *ngIf="!isCollapsed && (content?.showCollapseToggle ?? true)"
                >
                    <span class="material-symbols-rounded" aria-hidden="true">keyboard_double_arrow_right</span>
                </button>
                <button
                    type="button"
                    class="btn-control close-btn"
                    (click)="close()"
                    title="Close"
                    *ngIf="showCloseButton"
                >
                    <span class="material-symbols-rounded" aria-hidden="true">close</span>
                </button>
            </div>
        </div>

        <!-- Panel Content -->
        <div class="panel-content">
            <!-- Dynamic Angular Component Host -->
            <ng-container #dynamicComponentHost></ng-container>

            <!-- Default content when no component is provided -->
            <div *ngIf="!content?.component" class="default-content">
                <p>{{ content?.data?.['message'] || 'Select an item to view details' }}</p>
            </div>
        </div>
    </div>

    <!-- Menu Options Panel - Right Side, Full Height -->
    <div class="menu-panel" *ngIf="showRightMenu()">
        <div class="panel-menu">
            <button
                *ngFor="let option of menuOptionsWithCollapseToggle"
                type="button"
                class="btn-menu-item"
                [class.disabled]="option.disabled"
                (click)="handleMenuAction(option)"
                [disabled]="option.disabled"
            >
                <span
                    [appTooltip]="option.tooltip || option.name"
                    [tooltipPosition]="'left'"
                    class="material-symbols-rounded"
                    aria-hidden="true"
                    >{{ option.icon }}</span
                >
                <!-- <span class="menu-text" *ngIf="isExpanded && !isCollapsed">{{ option.name }}</span> -->
            </button>
        </div>
    </div>
</div>
